import { type ReactFlowState, useStore, useViewport } from '@xyflow/react'
import type { CSSProperties } from 'react'
import { useEffect, useRef } from 'react'
import { HELPER_LINE_COLOR } from '../constants'

const canvasStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  position: 'absolute',
  zIndex: 10,
  pointerEvents: 'none',
}

export type HelperLinesProps = {
  horizontal?: number
  vertical?: number
}

export default function HelperLines({
  horizontal,
  vertical,
}: HelperLinesProps) {
  const width = useStore((state: ReactFlowState) => state.width)
  const height = useStore((state: ReactFlowState) => state.height)
  const { x: translateX, y: translateY, zoom } = useViewport()

  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    const canvas = canvasRef.current
    const ctx = canvas?.getContext('2d')

    if (!ctx || !canvas) {
      return
    }

    const dpi = window.devicePixelRatio
    canvas.width = width * dpi
    canvas.height = height * dpi

    ctx.scale(dpi, dpi)
    ctx.clearRect(0, 0, width, height)
    ctx.strokeStyle = HELPER_LINE_COLOR

    if (typeof vertical === 'number') {
      ctx.moveTo(vertical * zoom + translateX, 0)
      ctx.lineTo(vertical * zoom + translateX, height)
      ctx.stroke()
    }

    if (typeof horizontal === 'number') {
      ctx.moveTo(0, horizontal * zoom + translateY)
      ctx.lineTo(width, horizontal * zoom + translateY)
      ctx.stroke()
    }
  }, [width, height, translateX, translateY, zoom, horizontal, vertical])

  return (
    <canvas
      ref={canvasRef}
      className="react-flow__canvas"
      style={canvasStyle}
    />
  )
}
